import styled, { css } from 'styled-components'
import { ImageWrapper } from '../../../shares/components/DocumentItem/DocumentItem.styles'

export const DroppableArea = styled(ImageWrapper)<{
  $isDraggedOver: boolean
}>(
  ({
    $isDraggedOver,
    theme: {
      colors,
      transitions: { duration, timing },
    },
  }) => css`
    width: 100%;
    margin: 0;
    padding: 0;
    background: inherit;
    border-radius: 10px; /* stylelint-disable-line scales/radii */
    box-shadow: ${colors.thumbnails.shadow};
    transition: box-shadow ${duration[2]} ${timing.easeInOut};

    &:hover {
      box-shadow: ${colors.thumbnails.shadowHover};
    }

    &::before {
      content: none;
    }

    &::after {
      box-shadow: none;
      pointer-events: none;

      ${$isDraggedOver &&
      css`
        box-shadow: inset 0 0 0 4px ${colors.sketch.D};
        background: ${colors.sketch.F};
        border-radius: 10px; /* stylelint-disable-line scales/radii */
      `}
    }
  `
)
